import React, { useMemo } from 'react';
import { deriveMobiliers, formatDateFr } from '../ipHelpers';

const ConformityBadge = ({ conformity }) => {
  const map = {
    conform: { dot: 'bg-green-500', cls: 'bg-green-50 text-green-700 dark:bg-green-900/30 dark:text-green-300', label: 'Conforme' },
    nonconform: { dot: 'bg-red-500', cls: 'bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-300', label: 'Non conforme' },
    pending: { dot: 'bg-amber-500', cls: 'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300', label: 'En cours' },
  };
  const cfg = map[conformity];
  if (!cfg) {
    return (
      <span className="inline-flex items-center text-xs font-medium px-2.5 py-1 rounded-full bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400">
        —
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center gap-1 text-xs font-medium px-2.5 py-1 rounded-full ${cfg.cls}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
};

export default function IPMobiliersTab({ calls }) {
  const mobiliers = useMemo(() => deriveMobiliers(calls), [calls]);

  if (mobiliers.length === 0) {
    return <p className="text-gray-500 dark:text-gray-400 italic text-center py-8">Aucun mobilier référencé.</p>;
  }

  return (
    <div className="space-y-3">
      {mobiliers.map((m) => (
        <div
          key={m.name}
          className="flex items-center justify-between gap-3 p-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800"
        >
          <div className="min-w-0 flex-1 text-left">
            <div className="font-semibold text-gray-800 dark:text-white">
              <span className="inline-block bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded-lg">{m.name}</span>
            </div>
            <div className="text-sm text-gray-500 dark:text-gray-400 mt-2 flex flex-wrap gap-x-3 gap-y-1">
              {m.brand && (
                <span>
                  Marque <span className="font-medium text-gray-700 dark:text-gray-300">{m.brand}</span>
                </span>
              )}
              {m.lastVisit && (
                <span>
                  Dernière visite <span className="font-medium text-gray-700 dark:text-gray-300">{formatDateFr(m.lastVisit)}</span>
                </span>
              )}
              <span>
                {m.ticketCount} ticket{m.ticketCount > 1 ? 's' : ''}
                {m.openCount > 0 && <span className="text-amber-600 dark:text-amber-400"> · {m.openCount} ouvert{m.openCount > 1 ? 's' : ''}</span>}
              </span>
            </div>
          </div>
          <ConformityBadge conformity={m.conformity} />
        </div>
      ))}
    </div>
  );
}
